<template>
    <div class="service-list-item" @click='toDetail(service.id)'>
      <div class="banner">
        <img alt="" :src="service.pic | formatImgUrl(336,234,true)"/>
      </div>
      <div class="info">
        <span class='fw500'>{{service.name}}</span>
        <span class="f34">{{service.priceText}}</span>
      </div>
      <div class="detail f22 grey9">{{service.content}}</div>
      <div class="sale-num grey9" v-if='service.totalSalesNumber'>已售{{service.totalSalesNumber}}</div>
    </div>
</template>

<script>
  import zhugeObj from '@/assets/js/track'
  export default {
    name: 'service-list-item',
    props: {
      service: {
        type: Object,
        default: {}
      },
    },
    computed: {
      
    },
    methods: {
      toDetail(serviceId){
        let cid = this.service.categoryId;
        this.$router.push({ name : 'serviceDetail' , query:{serviceId:serviceId}})
      }
    }
  }
</script>

<style scoped lang="scss">
  .service-list-item{
    width: 336px;
    height: 420px;
    position: relative;
    box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
    border-radius:6px;
    .banner{
      width: 336px;
      height: 234px;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .info{
      margin: 0 20px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .f34{
        color: #F24949;
      }
      border-bottom: 2px solid #eee;
    }
    .detail{
      padding: 0 20px;
      height: 60px;
      line-height: 30px;
      margin-top: 8px;
      word-break: break-all;

      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/

      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/

      -webkit-line-clamp: 2; /** 显示的行数 **/

      overflow: hidden;  /** 隐藏超出的内容 **/
    }
    .sale-num{
      font-size: 20px;
      position: absolute;
      right: 20px;bottom: 18px;
    }
  }
</style>
